const suppressedChatIds = new Set<string>();

export function suppressTerminalResume(chatId: string): void {
  suppressedChatIds.add(chatId);
}

export function isTerminalResumeSuppressed(chatId: string): boolean {
  return suppressedChatIds.has(chatId);
}

export function isForegroundChatWorkSuppressed({
  chatId,
  sessionId,
}: {
  chatId?: string;
  sessionId?: string;
}): boolean {
  const candidates = [chatId, sessionId].filter(
    (id): id is string => typeof id === 'string' && id.length > 0,
  );

  for (const suppressedChatId of suppressedChatIds) {
    for (const candidate of candidates) {
      if (
        candidate === suppressedChatId ||
        candidate.startsWith(`${suppressedChatId}:`)
      ) {
        return true;
      }
    }
  }

  return false;
}

export function clearTerminalResumeSuppression(chatId: string): void {
  suppressedChatIds.delete(chatId);
}
